export default __webpack_public_path__ + "styles/RichTextControl.4ae039f51c0b699c56936dc2f929ebf5.css";